/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_Aspect_RatioInputs */

const en_image_inspector_aspect_ratio = /** @type {(inputs: Image_Inspector_Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aspect ratio`)
};

const ar_image_inspector_aspect_ratio = /** @type {(inputs: Image_Inspector_Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نسبة الأبعاد`)
};

const bn_image_inspector_aspect_ratio = /** @type {(inputs: Image_Inspector_Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যাসপেক্ট রেশিও`)
};

const de_image_inspector_aspect_ratio = /** @type {(inputs: Image_Inspector_Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seitenverhältnis`)
};

const es_image_inspector_aspect_ratio = /** @type {(inputs: Image_Inspector_Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relación de aspecto`)
};

const fr_image_inspector_aspect_ratio = /** @type {(inputs: Image_Inspector_Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapport d'aspect`)
};

const pt_image_inspector_aspect_ratio = /** @type {(inputs: Image_Inspector_Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proporção`)
};

const zh_image_inspector_aspect_ratio = /** @type {(inputs: Image_Inspector_Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`宽高比`)
};

const tr_image_inspector_aspect_ratio = /** @type {(inputs: Image_Inspector_Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En-boy oranı`)
};

const ru_image_inspector_aspect_ratio = /** @type {(inputs: Image_Inspector_Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Соотношение сторон`)
};

const pl_image_inspector_aspect_ratio = /** @type {(inputs: Image_Inspector_Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proporcje`)
};

/**
* | output |
* | --- |
* | "Aspect ratio" |
*
* @param {Image_Inspector_Aspect_RatioInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_aspect_ratio = /** @type {((inputs?: Image_Inspector_Aspect_RatioInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_Aspect_RatioInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_aspect_ratio(inputs)
	if (locale === "bn") return bn_image_inspector_aspect_ratio(inputs)
	if (locale === "de") return de_image_inspector_aspect_ratio(inputs)
	if (locale === "es") return es_image_inspector_aspect_ratio(inputs)
	if (locale === "fr") return fr_image_inspector_aspect_ratio(inputs)
	if (locale === "pt") return pt_image_inspector_aspect_ratio(inputs)
	if (locale === "zh") return zh_image_inspector_aspect_ratio(inputs)
	if (locale === "tr") return tr_image_inspector_aspect_ratio(inputs)
	if (locale === "ru") return ru_image_inspector_aspect_ratio(inputs)
	if (locale === "pl") return pl_image_inspector_aspect_ratio(inputs)
	return en_image_inspector_aspect_ratio(inputs)
});